import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const api = axios.create({
  baseURL: `${API_URL}apis/chat`,
});

api.interceptors.request.use((config) => {
  const cred = localStorage.getItem('cred');
  if (cred) {
    const token = JSON.parse(cred).token;
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
